export const DEFAULT_PROMPT_VERSION_TAGS = [
  {
    name: "production",
    description: "The version deployed to production",
  },
  {
    name: "staging",
    description: "The version deployed to staging",
  },
  {
    name: "development",
    description: "The version deployed for development",
  },
];
